/**
 * Options-API mixin that wires standard overlay behaviour into any component
 * that has an `open` prop, emits `close`, and exposes a `ref="overlayRoot"` on
 * its focusable container:
 *   - locks body scroll while open
 *   - Escape closes (topmost overlay only)
 *   - Tab is trapped within the overlay
 *   - focus moves into the overlay on open and returns to the trigger on close
 */
import {
  lockScroll, unlockScroll, focusFirst, trapTab,
  pushOverlay, popOverlay, isTopOverlay
} from './overlay'

export default {
  watch: {
    open(val) {
      if (val) this.$_activateOverlay()
      else this.$_deactivateOverlay()
    }
  },
  mounted() {
    if (this.open) this.$_activateOverlay()
  },
  beforeUnmount() {
    this.$_deactivateOverlay()
  },
  methods: {
    $_activateOverlay() {
      if (this.$_overlayActive) return
      this.$_overlayActive = true
      this.$_prevFocus = document.activeElement
      lockScroll()
      pushOverlay(this)
      this.$_onKey = (e) => {
        if (!isTopOverlay(this)) return
        if (e.key === 'Escape') { this.$emit('close'); return }
        trapTab(e, this.$refs.overlayRoot)
      }
      document.addEventListener('keydown', this.$_onKey)
      this.$nextTick(() => focusFirst(this.$refs.overlayRoot))
    },
    $_deactivateOverlay() {
      if (!this.$_overlayActive) return
      this.$_overlayActive = false
      document.removeEventListener('keydown', this.$_onKey)
      this.$_onKey = null
      popOverlay(this)
      unlockScroll()
      if (this.$_prevFocus && this.$_prevFocus.focus) this.$_prevFocus.focus()
      this.$_prevFocus = null
    }
  }
}
